import FieldTypeReferenceDto from "../FieldTypeReferenceDto";
import FilterParameterDto from "../datasourcemodule/FilterParameterDto";
import DataTableFieldParameterDefinitionDto from "../datasourcemodule/DataTableFieldParameterDefinitionDto";

class DataTableFieldMappingDto {
    SourceFieldReferenceId: number;
    TransformationType: number | null;
    TransformationParameters: string | null;
    AggregationGroupBy: boolean;
    AggregationType: number | null;
    AggregationParameters: string | null;
    Name: string;
    Type: FieldTypeReferenceDto;
    DisplayName: string;
    DataTableName: string;
    Filters: FilterParameterDto[];
    DeclaredVariables: DataTableFieldParameterDefinitionDto[];

    constructor(
        sourceFieldReferenceId: number,
        transformationType: number | null,
        transformationParameters: string | null,
        aggregationGroupBy: boolean,
        aggregationType: number | null,
        aggregationParameters: string | null,
        name: string,
        type: FieldTypeReferenceDto,
        displayName: string,
        dataTableName: string,
        filters: FilterParameterDto[],
        declaredVariables: DataTableFieldParameterDefinitionDto[] = []
    ) {
        this.SourceFieldReferenceId = sourceFieldReferenceId;
        this.TransformationType = transformationType;
        this.TransformationParameters = transformationParameters;
        this.AggregationGroupBy = aggregationGroupBy;
        this.AggregationType = aggregationType;
        this.AggregationParameters = aggregationParameters;
        this.Name = name;
        this.Type = type;
        this.DisplayName = displayName;
        this.DataTableName = dataTableName;
        this.Filters = filters;
        this.DeclaredVariables = declaredVariables;
    }
}

export default DataTableFieldMappingDto;
